@let data = section();

<div class="tg-section">
    <section
        class="cms-widget-list tg-container"
        [class.cms-widget-list--content-left]="data.widgetListBlockContentPosition === 'left'"
    >
        @if (data.image?.url) {
            <div
                class="cms-widget-list__media"
                [style.flex-basis.%]="data.imageBlockWidthPct || null"
                [style.text-align]="data.imageAlignment || null"
            >
                @if (data.imageBlockTitle) {
                    <h3 class="tg-h3 cms-widget-list__media-title">{{ data.imageBlockTitle }}</h3>
                }
                <cms-image
                    [media]="data.image"
                    [style.max-width.px]="data.imageMaxWidthPx || null"
                />
            </div>
        }

        <div
            class="cms-widget-list__content"
            [style.flex-basis.%]="data.contentBlockWidthPct || null"
            [style.text-align]="data.contentAlignment || null"
            [style.max-width.px]="data.contentBlockMaxWidthPx || null"
        >
            @if (data.titleContent) {
                <div class="cms-content" [innerHTML]="data.titleContent | trustHtml"></div>
            }
            @if (data.content) {
                <div class="cms-content" [innerHTML]="data.content | trustHtml"></div>
            }

            @if (data.items.length) {
                <ul class="cms-widget-list__items">
                    @for (item of data.items; track item.id) {
                        <li class="cms-widget-list__item">
                            @if (item.itemListMarker?.url) {
                                <cms-image
                                    class="cms-widget-list__marker"
                                    [media]="item.itemListMarker"
                                />
                            }
                            <span>{{ item.itemLabel }}</span>
                        </li>
                    }
                </ul>
            }

            @if (data.buttonLink) {
                <cms-btn class="cms-widget-list__cta" [config]="data.buttonLink" />
            }
        </div>
    </section>
</div>
